import { render, staticRenderFns } from "./OptInModal.vue?vue&type=template&id=bf35e966&scoped=true&"
import script from "./OptInModal.vue?vue&type=script&lang=js&"
export * from "./OptInModal.vue?vue&type=script&lang=js&"
import style0 from "./OptInModal.vue?vue&type=style&index=0&id=bf35e966&lang=scss&scoped=true&"
import style1 from "./OptInModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf35e966",
  null
  
)

export default component.exports